import axios from 'axios';
import { variables } from '../Variables';

export const getEstateJobStatus = async (estateId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetEstateJobStatus?estateId=${estateId}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log("api error", error);
        return "error";
    }
}

export const htmlToPlainText = (html) => {
    if (!html || typeof html !== 'string') return '';

    let text = html
        // ── 1. Remove <style> and <script> blocks entirely ──
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
        // ── 2. Normalize all line-break styles to \n BEFORE anything else ──
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .replace(/(<br\s*\/?>\s*){1,}/gi, '\n')
        // ── 3. Block-level elements → newline ──
        .replace(/<\/?(address|article|aside|blockquote|canvas|dd|dl|dt|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|noscript|ol|p|pre|section|summary|table|tfoot|thead|tbody|tr|td|th|ul|video|div)[^>]*>/gi, '\n')
        // ── 4. <hr> → visible separator ──
        .replace(/<hr[^>]*>/gi, '\n─────────────────────\n')
        // ── 5. Handle list items with bullet ──
        .replace(/<li[^>]*>/gi, '\n• ')
        // ── 6. Links → keep text only ──
        .replace(/<a[^>]*href="([^"]*)"[^>]*>([\s\S]*?)<\/a>/gi, '$2')
        // ── 7. Images → alt text if available ──
        .replace(/<img[^>]*alt="([^"]+)"[^>]*>/gi, '[$1]')
        .replace(/<img[^>]*>/gi, '')
        // ── 8. Strip all remaining HTML tags ──
        .replace(/<[^>]+>/g, '')
        // ── 9. Decode HTML entities ──
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&copy;/g, '©')
        .replace(/&reg;/g, '®')
        .replace(/&trade;/g, '™')
        .replace(/&mdash;/g, '—')
        .replace(/&ndash;/g, '–')
        .replace(/&bull;/g, '•')
        .replace(/&hellip;/g, '...')
        .replace(/&euro;/g, '€')
        .replace(/&pound;/g, '£')
        .replace(/&yen;/g, '¥')
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))        // decimal
        .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16))) // hex
        // ── 10. Clean up whitespace ──
        .replace(/\t/g, ' ')
        .replace(/ {2,}/g, ' ')
        .replace(/ +\n/g, '\n')
        .replace(/\n +/g, '\n');

    // ── 11. Strip blank/whitespace-only lines, keep only real content lines ──
    const lines = text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line.length > 0);

    // ── 12. Insert exactly ONE blank line before a "section header" line ──
    // A section header is a line ending in ":" (e.g. "Visit on the following time:",
    // "For the property:", "Your contact details:") OR the separator dashes/hr line.
    // We never add a blank line before the very first line of the email.
    const sectionHeaderPattern = /:$/;
    const separatorPattern = /^─+$|^-{3,}$/;

    const result = [];
    lines.forEach((line, index) => {
        const isSectionHeader = sectionHeaderPattern.test(line) || separatorPattern.test(line);
        const isFirstLine = index === 0;
        if (isSectionHeader && !isFirstLine) {
            result.push(''); // one blank line before this section starts
        }
        result.push(line);
    });

    return result.join('\n').trim();
}

// get property status from estate table in local db
export const getEstateStatusFromInDB = async (estateId, clientId) => {
    try {       // replace propertyId => getActiveLatestEstateIdInDB
        let url = `${variables.API_URL}LocalEvents/GetEstateStatus?estateId=${estateId}&clientId=${clientId}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.get(url, config);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}
